<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="m12 21.5-1.4-1.4c-5.2-4.8-8.6-8-8.6-12C2 5 4.4 2.6 7.5 2.6A6 6 0 0 1 12 4.7a6 6 0 0 1 4.5-2.2c3 0 5.5 2.5 5.5 5.7 0 3.9-3.4 7.1-8.5 12z"
    />
  </svg>
</template>
